import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import { type AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import ErpOrdersListItem from './ErpOrdersListItem';
import ErpOrdersDetails from './details/ErpOrdersDetails';

import buttons from './ErpOrdersButtons';
// import events from './ErpOrdersEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ authorizer }) => authorizer.can('view', 'erp_orders'),
	routes: [
		{
			path: 'erp/orders/details/:id/:tabId?',
			element: (
				<DetailsPage
					key="erp-orders/details"
					module="erp_orders"
					tabs={ErpOrdersDetails}
					buttons={buttons.details}
				/>
			)
		},
		{
			path: 'erp/orders/:tabId?',
			element: (
				<ViewPage
					key="erp-orders/view"
					module="erp_orders"
					content={{ type: 'list', itemLayout: ErpOrdersListItem, id: 'erpOrdersView' }}
					buttons={buttons.view}
					showExportButton={false}
				/>
			)
		}
	]
};

export default routes;
